export default __webpack_public_path__ + "static/media/rook_black.fd4e01f5.svg";